import { render, staticRenderFns } from "./DemoSendFeedbackButton.vue?vue&type=template&id=fa02e28c&scoped=true"
import script from "./DemoSendFeedbackButton.vue?vue&type=script&lang=js"
export * from "./DemoSendFeedbackButton.vue?vue&type=script&lang=js"
import style0 from "./DemoSendFeedbackButton.vue?vue&type=style&index=0&id=fa02e28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa02e28c",
  null
  
)

export default component.exports